import MainHeading from "../../components/comman/MainHeading";
import { useEffect, useState } from "react";
import { callApi } from "../../ApiHelper/ApiHelper";
import { apiUrl } from "../../ApiHelper/ApiUrl";
import moment from "moment";
import PaginationComponent from "../../components/comman/PaginationComponent";
import NoRecordIcon from "../../components/Icons/NoRecordIcon";

export default function Logs({
  type,
  id,
  refreshLogs,
  setRefreshLogs,
  name,
  showBackButton,
  hideHeading = false,
}) {
  const [pageStates, setPageStates] = useState({
    currentPage: 1,
    pageSize: 10,
    count: 0,
    totalPages: 0,
    tableLoader: false,
    logsData: [],
  });

  const GetLogsData = () => {
    let API = `${apiUrl?.get_logs}?pageNumber=${pageStates?.currentPage}&pageSize=${pageStates?.pageSize}&type=${type}&id=${id}`;
    setPageStates((pre) => ({
      ...pre,
      tableLoader: true,
    }));
    callApi(API, { method: "GET" }).then((response) => {
      setPageStates((pre) => ({
        ...pre,
        tableLoader: false,
      }));
      if (setRefreshLogs) {
        setRefreshLogs(false);
      }
      if (response?.status) {
        setPageStates((pre) => ({
          ...pre,
          logsData: response?.data?.logs || [],
          totalPages: response?.data?.pageInfo?.totalPages,
          count: response?.data?.pageInfo?.total,
        }));
      } else {
        setPageStates((pre) => ({
          ...pre,
          logsData: [],
        }));
      }
    });
  };

  useEffect(() => {
    GetLogsData();
  }, [pageStates?.currentPage, refreshLogs]);

  const PageChangeHandler = (PageNo) => {
    if (PageNo > 0 && PageNo <= pageStates?.totalPages) {
      setPageStates((prev) => ({
        ...prev,
        currentPage: PageNo,
      }));
    }
  };

  return (
    <div className="content">
      {!hideHeading && (
        <MainHeading
          showBackButton={showBackButton}
          title={name ? name + "'s Logs" : "Logs"}
        />
      )}

      <div
        className="card border-0 shadow-sm rounded-3 overflow-hidden mb-4"
        style={{ background: "#ffffff" }}
      >
        <div
          className="card-header bg-white py-3 px-4 d-flex align-items-center justify-content-between border-bottom"
          style={{ borderColor: "#f1f5f9" }}
        >
          <div className="d-flex align-items-center gap-2">
            <span
              style={{
                fontSize: "16px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                lineHeight: 1,
                transform: "translateY(-1.5px)",
              }}
            >
              📜
            </span>
            <h5
              className="mb-0 fw-bold"
              style={{ fontSize: "14.5px", color: "#0f172a" }}
            >
              {name ? `${name}'s Activity History` : "Audit Trail & Activity History"}
            </h5>
          </div>
          {pageStates?.count > 0 && (
            <span
              className="badge bg-light text-secondary border px-2.5 py-1 rounded-pill"
              style={{ fontSize: "11.5px", fontWeight: 600 }}
            >
              {pageStates.count} {pageStates.count === 1 ? "Event" : "Events"}
            </span>
          )}
        </div>

        <div className="card-body p-4">
          {pageStates?.tableLoader ? (
            <div className="d-flex flex-column gap-3 py-2">
              {[1, 2, 3].map((_, index) => (
                <div key={index} className="d-flex align-items-start gap-3">
                  <div
                    className="rounded-circle flex-shrink-0"
                    style={{
                      width: "20px",
                      height: "20px",
                      marginTop: "10px",
                      background: "#f1f5f9",
                    }}
                  />
                  <div
                    className="flex-grow-1 p-3 rounded-2"
                    style={{ background: "#f8fafc", border: "1px solid #f1f5f9" }}
                  >
                    <div
                      className="rounded-1 mb-2"
                      style={{ height: "14px", width: "65%", background: "#e2e8f0" }}
                    />
                    <div
                      className="rounded-1"
                      style={{ height: "11px", width: "35%", background: "#f1f5f9" }}
                    />
                  </div>
                </div>
              ))}
            </div>
          ) : pageStates?.logsData?.length > 0 ? (
            <div className="position-relative">
              {pageStates.logsData.map((log, index) => {
                const isLast = index === pageStates.logsData.length - 1;
                const isFirst = index === 0;
                return (
                  <div
                    key={log?.id || index}
                    className="d-flex position-relative"
                    style={{
                      paddingBottom: isLast ? "0" : "18px",
                    }}
                  >
                    {/* Vertical connector line */}
                    {!isLast && (
                      <div
                        style={{
                          position: "absolute",
                          left: "9px",
                          top: "20px",
                          bottom: "-18px",
                          width: "2px",
                          background: "#e2e8f0",
                          zIndex: 0,
                        }}
                      />
                    )}

                    {/* Timeline node dot */}
                    <div
                      className="rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                      style={{
                        width: "20px",
                        height: "20px",
                        marginTop: "10px",
                        background: isFirst ? "#eff6ff" : "#ffffff",
                        border: `2px solid ${isFirst ? "#2563eb" : "#cbd5e1"}`,
                        zIndex: 1,
                        boxShadow: isFirst
                          ? "0 0 0 3px rgba(37, 99, 235, 0.15)"
                          : "none",
                      }}
                    >
                      <div
                        style={{
                          width: "6px",
                          height: "6px",
                          borderRadius: "50%",
                          background: isFirst ? "#2563eb" : "#94a3b8",
                        }}
                      />
                    </div>

                    {/* Event details tile */}
                    <div className="flex-grow-1 ms-3">
                      <div
                        className="rounded-2"
                        style={{
                          padding: "11px 15px",
                          background: "#f8fafc",
                          border: "1px solid #f1f5f9",
                          transition: "all 0.2s ease",
                        }}
                      >
                        <div className="d-flex align-items-start justify-content-between flex-wrap gap-2 mb-1.5">
                          <span
                            className="fw-semibold text-dark"
                            style={{ fontSize: "13.5px", lineHeight: "1.4" }}
                          >
                            {log?.text}
                          </span>
                          {log?.createdAt && (
                            <span
                              className="badge rounded-pill bg-white text-secondary border px-2 py-1 flex-shrink-0"
                              style={{ fontSize: "11px", fontWeight: 500 }}
                              title={moment(log.createdAt).format("DD MMM YYYY, hh:mm:ss A")}
                            >
                              {moment(log.createdAt).fromNow()}
                            </span>
                          )}
                        </div>

                        <div
                          className="text-secondary d-flex align-items-center gap-1.5"
                          style={{ fontSize: "11.5px" }}
                        >
                          <span
                            style={{
                              fontSize: "11px",
                              display: "inline-block",
                              transform: "translateY(-1px)",
                            }}
                          >
                            🕒
                          </span>
                          <span>
                            {log?.createdAt
                              ? moment(log.createdAt).format("DD MMM YYYY, hh:mm A")
                              : "--"}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : (
            <div className="text-center text-muted py-5">
              <div className="d-flex flex-column justify-content-center align-items-center no-data-error">
                <NoRecordIcon />
                <span
                  className="mt-2 fw-semibold text-secondary"
                  style={{ fontSize: "13.5px" }}
                >
                  No Activity Logs Available
                </span>
                <span className="text-muted small mt-0.5">
                  Events and status updates will appear here as actions occur.
                </span>
              </div>
            </div>
          )}

          <div className="mt-3">
            <PaginationComponent
              currentPage={pageStates?.currentPage}
              PageChangeHandler={PageChangeHandler}
              totalPages={pageStates?.totalPages}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
